// import Auth0Service from 'services/auth/Auth0Service';
import requestHandler from '../requestHandler';

const getOpsOwnDetails = () => requestHandler.get(`/api/v1/ops/self`, {});

export default getOpsOwnDetails;
